'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputStyled = exports.TextareaStyled = exports.TextareaAutosizeStyled = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTextareaAutosize = require('react-textarea-autosize');

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var propTypes = {
  /**
   * If bordered = false, TextField will have only bottom border
   */
  bordered: _propTypes2.default.bool,

  /**
   * Full-width TextField doesn't have borders
   */
  fullWidth: _propTypes2.default.bool,

  /**
   * If textfield is dense it has smaller paddings
   */
  dense: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),

  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  bordered: false,
  fullWidth: false,
  dense: false,
  disabled: false,
  colorScheme: 'neutral'
};

var displayName = function displayName(name) {
  return 'TextFieldStyled(' + name + ')';
};
/** PROP RECEIVERS */


var textfieldSize = function textfieldSize(_ref) {
  var dense = _ref.dense,
      fullWidth = _ref.fullWidth,
      bordered = _ref.bordered,
      themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
      styleKey = bordered ? 'bordered' : 'underlined';
  var source = null;

  if (dense && !fullWidth) {
    source = theme.reactackle.components.textfield.textfield.size.dense;
  } else if (dense && fullWidth) {
    source = theme.reactackle.components.textfield.textfield.size.denseFullWidth;
  } else if (!dense && fullWidth) {
    source = theme.reactackle.components.textfield.textfield.size.fullWidth;
  } else {
    source = theme.reactackle.components.textfield.textfield.size;
  }

  var _source = source,
      paddingY = _source.paddingY,
      paddingX = _source.paddingX;
  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX[styleKey]) + ';\n  ';
};

var basicStyles = function basicStyles(_ref2) {
  var themeFromProvider = _ref2.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  return (0, _styledComponents.css)(['font-family:', ';'], theme.reactackle.components.textfield.textfield.fontFamily);
};

var textfieldStyle = function textfieldStyle(_ref3) {
  var disabled = _ref3.disabled,
      colorScheme = _ref3.colorScheme,
      themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = theme.reactackle.components.textfield.textfield.state;
  var neutralStyles = colorScheme === 'neutral' && (0, _styledComponents.css)(['background-color:', ';color:', ';&:hover{outline:none;background-color:', ';color:', ';}&:focus{outline:none;background-color:', ';color:', ';}'], source.backgroundColor, source.fontColor, source.hover.backgroundColor, source.hover.fontColor, source.focus.backgroundColor, source.focus.fontColor);
  var stateStyles = colorScheme !== 'neutral' && (0, _styledComponents.css)(['&,&:hover,&:focus{background-color:', ';color:', ';outline:none;}'], source[colorScheme].backgroundColor, source[colorScheme].fontColor);
  var disabledStyles = '\n    cursor: default;\n    user-select: none;\n\n    &,\n    &:hover,\n    &:focus {\n      background-color: ' + source.disabled.backgroundColor + ';\n      color: ' + source.disabled.fontColor + ';\n      outline: none;\n    }\n  ';
  var styles = null;
  if (disabled) styles = disabledStyles;else if (colorScheme === 'neutral') styles = neutralStyles;else styles = stateStyles;
  return styles;
};

var placeholderStyles = function placeholderStyles(_ref4) {
  var themeFromProvider = _ref4.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  return '\n    color: ' + theme.reactackle.components.textfield.placeholder.fontColor + ';\n  ';
};
/** STYLES */


var styles = function styles(props) {
  return (0, _styledComponents.css)(['border-width:0;text-overflow:ellipsis;flex-grow:1;width:100%;resize:', ';max-width:100%;font-size:inherit;line-height:inherit;z-index:1;', ' ', ' ', ' &::placeholder{', '}', ''], props.resize === 'none' ? 'none' : 'both', textfieldSize(props), basicStyles(props), textfieldStyle(props), placeholderStyles(props), (0, _reactackleCore.transition)('color, background-color, box-shadow'));
};

var TextareaAutosizeStyled = (0, _styledComponents2.default)(function (_ref5) {
  var bordered = _ref5.bordered,
      fullWidth = _ref5.fullWidth,
      dense = _ref5.dense,
      disabled = _ref5.disabled,
      colorScheme = _ref5.colorScheme,
      focus = _ref5.focus,
      theme = _ref5.theme,
      saveRef = _ref5.saveRef,
      props = _objectWithoutProperties(_ref5, ['bordered', 'fullWidth', 'dense', 'disabled', 'colorScheme', 'focus', 'theme', 'saveRef']);

  return _react2.default.createElement(_reactTextareaAutosize2.default, _extends({}, props, {
    inputRef: saveRef
  }));
}).withConfig({
  displayName: 'TextFieldElementStyled__TextareaAutosizeStyled'
})(['', ''], styles);
exports.TextareaAutosizeStyled = TextareaAutosizeStyled;
TextareaAutosizeStyled.propTypes = _extends({}, propTypes, _reactTextareaAutosize2.default.propTypes, {
  saveRef: _propTypes2.default.func.isRequired
});
TextareaAutosizeStyled.defaultProps = _extends({}, defaultProps, _reactTextareaAutosize2.default.defaultProps);
TextareaAutosizeStyled.displayName = displayName(_reactTextareaAutosize2.default.displayName || 'TextareaAutosize');

var TextareaStyled = exports.TextareaStyled = _styledComponents2.default.textarea.withConfig({
  displayName: 'TextFieldElementStyled__TextareaStyled'
})(['', ''], styles);

TextareaStyled.propTypes = propTypes;
TextareaStyled.defaultProps = defaultProps;
TextareaStyled.displayName = displayName('Textarea');

var InputStyled = exports.InputStyled = _styledComponents2.default.input.withConfig({
  displayName: 'TextFieldElementStyled__InputStyled'
})(['', ''], styles);

InputStyled.propTypes = propTypes;
InputStyled.defaultProps = defaultProps;
InputStyled.displayName = displayName('Input');